import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";
import {useId} from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {OptionItem, SingleSelect} from "@khanacademy/wonder-blocks-dropdown";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {LabelMedium} from "@khanacademy/wonder-blocks-typography";

import useLocalesQuery from "./use-locales-query.ts";

interface Props {
    userLanguage: string;
    onChange: (language: string) => void;
    disabled: boolean;
}

const MAX_HEIGHT = 320;

const LanguageSelector = ({
    userLanguage,
    disabled,
    onChange,
}: Props): React.ReactNode => {
    const languageSelectorId = useId();
    const {locales, isLoading, isError} = useLocalesQuery();

    return (
        <View style={{gap: sizing.size_120}}>
            <LabelMedium tag="label" htmlFor={languageSelectorId}>
                {t`Primary Language`}
            </LabelMedium>
            <SingleSelect
                disabled={isLoading || isError || disabled}
                onChange={onChange}
                placeholder={t`Language`}
                selectedValue={userLanguage}
                style={[styles.dropdown, disabled && styles.disabled]}
                dropdownStyle={styles.dropdownStyle}
                id={languageSelectorId}
            >
                {[
                    {
                        localName: t`Not specified`,
                        id: "unspecified",
                    },
                    ...locales,
                ].map((locale) => (
                    <OptionItem
                        key={locale.id}
                        label={locale.localName}
                        value={locale.id}
                    />
                ))}
            </SingleSelect>
        </View>
    );
};
export default LanguageSelector;

const styles = StyleSheet.create({
    dropdown: {
        width: "100%",
    },
    dropdownStyle: {
        maxHeight: MAX_HEIGHT,
    },
    disabled: {
        backgroundColor: semanticColor.action.primary.disabled.foreground,
    },
});
